import { get } from '../../utils/apiClient'

export const setConversations = (conversations) => ({
  type: 'SET_CONVERSATIONS',
  payload: conversations,
})

export const addConversation = (conversation) => ({
  type: 'ADD_CONVERSATION',
  payload: conversation,
})

export const updateConversation = (payload) => ({
  type: 'UPDATE_CONVERSATION',
  payload: {
    ...payload,
    // S'assurer que tous les champs sont sérialisables
    timestamp: payload.timestamp || new Date().toISOString(),
    unreadCount: typeof payload.unreadCount === 'number' ? payload.unreadCount : undefined,
    incrementUnread: !!payload.incrementUnread,
  },
})

export const updateConversations = (conversations) => {
  return {
    type: 'SET_CONVERSATIONS',
    payload: conversations,
  }
}

export const updateConversationsUnread = (id, unreadCount) => ({
  type: 'UPDATE_CONVERSATIONS_UNREAD',
  payload: { id, unreadCount },
})

export const removeConversation = (id) => ({
  type: 'REMOVE_CONVERSATION',
  payload: id,
})

export const setLoading = (isLoading) => ({
  type: 'SET_LOADING',
  payload: isLoading,
})

export const setError = (error) => ({
  type: 'SET_ERROR',
  payload: error,
})

export const setCurrentConversationId = (conversationId) => ({
  type: 'SET_CURRENT_CONVERSATION_ID',
  payload: conversationId,
})

// chargement des conversations au démarrage de l'application
export const fetchConversations = () => async (dispatch, getState) => {
  // Vérifier si un chargement est déjà en cours
  const { loading } = getState().conversations
  if (loading) {
    console.log('Chargement des conversations déjà en cours, attente...')

    // Ajoutons un filet de sécurité : si loading reste bloqué à true pendant plus de 5 secondes,
    // on force le reset de l'état et on autorise une nouvelle requête
    setTimeout(() => {
      const { loading: stillLoading } = getState().conversations
      if (stillLoading) {
        console.log('Timeout de chargement dépassé, reset du loading state')
        dispatch(setLoading(false))
        // Tenter de recharger une fois l'état réinitialisé
        dispatch(fetchConversations())
      }
    }, 5000) // 5 secondes de timeout

    return
  }

  try {
    dispatch(setLoading(true))

    // ✅ SECURITY: Vérifier via userId (cookie httpOnly gère l'auth)
    const userId = localStorage.getItem('userId')
    if (!userId) {
      dispatch(setError('Non authentifié'))
      return
    }

    const data = await get('/messaging/conversations', {
      headers: {
        'Cache-Control': 'no-cache',
      },
    })

    const formatted = data
      .map((conv) => ({
        ...conv,
        updatedAt: conv.updatedAt || new Date().toISOString(),
        members: conv.members || [],
        messages: (conv.messages || []).map((msg) => ({
          ...msg,
          createdAt: msg.created_at || msg.createdAt || new Date().toISOString(),
        })),
        lastMessage: conv.lastMessage || conv.messages?.[0] || null,
        unreadCount: conv.unreadCount || 0,
        timestamp: conv.updatedAt || new Date().toISOString(),
      }))
      .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))

    dispatch(setConversations(formatted))
    return formatted
  } catch (error) {
    console.error('fetchConversations error:', error)
    dispatch(setError('Impossible de charger les conversations'))
  } finally {
    dispatch(setLoading(false))
  }
}
